import React, { useState } from "react";
import "./style.scss";
import { NavLink } from "react-router-dom";
import cn from "classnames";
import ContainerDiv from "../../modules/ui/ContainerDiv";
import { useDispatch, useSelector } from "react-redux";
import { MODAL_TOGGLE } from "../../store/Modal/Modal.constant";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { ShoppingCart, ArrowLeft, Users } from "lucide-react";

const Header = ({
  user_id,
  auth,
  isJoin,
  creator_id,
  cartCount: cartCountProp,
  onCartClick,
  checkoutMode,
  backToUrl,
  backToLabel = "Back to Restaurant",
}) => {
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const products = useSelector((state) => state.products[user_id]);
  let reduxCartCount = 0;
  (products?.myProducts || []).forEach((item) => {
    if (item.menu_items?.length) {
      Object.values(item.menu_items_mapping || {}).forEach(
        (mapping) => (reduxCartCount += +mapping.quantity)
      );
    } else {
      reduxCartCount += item.quantity || 1;
    }
  });
  const cartCount = cartCountProp ?? reduxCartCount;
  const groupOrderDashboardLink = `/grouporder-dashboard/${creator_id}`;
  const reportLink = `/grouporder-dashboard/${user_id}/reports`;
  const manageMembersLink = `/grouporder-dashboard/${user_id}/manage-members`;
  const emailNotificationLink = `/grouporder-dashboard/${user_id}/email-notification`;
  const deliveryControlPanelLink = `/grouporder-dashboard/${user_id}/delivery-control-panel`;

  const onLoad = () => {
    localStorage.clear();
    window.location.reload();
    setToggle(false);
  };
  const onClickProfile = () => {
    dispatch({
      type: MODAL_TOGGLE,
      payload: { data: "isModalEditProfile", user_id, boolean: true },
    });
    setToggle(false);
  };
  const handleClick = (e) => {
    if (!creator_id) e.preventDefault();
  };

  const onClickSetting = () => {
    dispatch({
      type: MODAL_TOGGLE,
      payload: { data: "isModalSetting", user_id, boolean: true },
    });
    setToggle(false);
  };
  const onClickGroupOrderSetting = () => {
    dispatch({
      type: MODAL_TOGGLE,
      payload: { data: "isModalGroupSetting", user_id, boolean: true },
    });
    setToggle(false);
  };

  if (checkoutMode) {
    return (
      <header className="header__checkout">
        <div className="container">
          <div className="checkout__bar">
            <NavLink to="/" className="brand-wordmark">
              <span className="brand-badge" role="img" aria-label="panda">🐼</span>
              <span className="brand-text">
                Panda<span className="brand-text--accent">On</span>Wheels
              </span>
            </NavLink>
            <div className="checkout__actions">
              {backToUrl && (
                <a href={backToUrl} className="checkout__back-btn">
                  <ArrowLeft size={16} />
                  {backToLabel}
                </a>
              )}
              <span className="checkout__badge">
                <Users size={14} />
                Corporate Order
              </span>
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <>
    <header className={cn({ header__welcome: isJoin })}>
      <div className="container">
        <div className="outer__header">
          <ContainerDiv container={isJoin} className="header__logo">
            <div className="logo__wrap">
              <NavLink onClick={handleClick} to={groupOrderDashboardLink} className="brand-wordmark">
                <span className="brand-badge" role="img" aria-label="panda">🐼</span>
                <span className="brand-text">
                  Panda<span className="brand-text--accent">On</span>Wheels
                </span>
              </NavLink>
            </div>
            <div className="group__info">
              <NavLink onClick={handleClick} to={groupOrderDashboardLink}>
                CORPORATE ORDER
              </NavLink>
            </div>
          </ContainerDiv>
          {isJoin && (
            <div className="nav-extras">
              <button
                type="button"
                className="cart-btn"
                aria-label="Cart"
                onClick={onCartClick}
              >
                <ShoppingCart className="cart-btn__icon" aria-hidden="true" />
                <span className="cart-btn__count">{cartCount}</span>
              </button>
            </div>
          )}
          {isJoin ? (
            <div
              className={cn("welcome__back--dropdown", {
                focused__dropdown: toggle,
              })}
            >
              <div
                className="avatar-toggle"
                role="button"
                tabIndex={0}
                aria-label="Open account menu"
                aria-expanded={toggle}
                onClick={() => setToggle(!toggle)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    setToggle(!toggle);
                  }
                }}
              >
                {auth?.profile_image_url ? (
                  <img
                    src={
                      process.env.REACT_APP_API_URL + auth.profile_image_url
                    }
                    alt={auth?.first_name || "User"}
                  />
                ) : (
                  <span className="avatar-toggle__initials">
                    {(auth?.first_name?.[0] || "U").toUpperCase()}
                    {(auth?.last_name?.[0] || "").toUpperCase()}
                  </span>
                )}
              </div>
              <div className={cn("dropdown__profile", { disabled: !toggle })}>
                <ul>
                  <li>
                    <button onClick={onClickProfile} type="button">
                      <span>
                        <img src="/img/dropdown1.svg" alt="dropdown" />
                      </span>
                      Update Account
                    </button>
                  </li>
                  {auth?.is_dashboard_admin == true && (
                    <>
                      <li>
                        <button onClick={onClickSetting} type="button">
                          <span>
                            <img src="/img/settingicon.svg" alt="dropdown" />
                          </span>
                          Privacy Setting
                        </button>
                      </li>
                      <li>
                        <button onClick={onClickGroupOrderSetting} type="button">
                          <span>
                            <img src="/img/settingicon.svg" alt="dropdown" />
                          </span>
                          Group Setting
                        </button>
                      </li>
                    </>
                  )}
                  {location.pathname !== reportLink && auth?.is_dashboard_admin == true && (
                    <li>
                      <button type="button">
                        <span>
                          <img src="/img/report.png" alt="report" />
                        </span>

                        <Link
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                          to={reportLink}
                        >
                          Reports
                        </Link>
                      </button>
                    </li>
                  )}
                  {location.pathname !== manageMembersLink && auth?.is_dashboard_admin == true && (
                    <li>
                      <button type="button">
                        <span>
                          <img src="/img/settingicon.svg" alt="report" />
                        </span>

                        <Link
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                          to={manageMembersLink}
                        >
                          Weekly Limit Settings
                        </Link>
                      </button>
                    </li>
                  )}
                  {location.pathname !== emailNotificationLink && auth?.is_dashboard_admin == true && (
                    <li>
                      <button type="button">
                        <span>
                          <img src="/img/settingicon.svg" alt="report" />
                        </span>

                        <Link
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                          to={emailNotificationLink}
                        >
                          Email Notification Setting
                        </Link>
                      </button>
                    </li>
                  )}
                  {location.pathname !== deliveryControlPanelLink && auth?.is_dashboard_admin == true && (
                    <li>
                      <button type="button">
                        <span>
                          <img src="/img/deliveryControlPanel.png" alt="deliveryControlPanel" />
                        </span>

                        <Link
                          style={{
                            color: "inherit",
                            textDecoration: "none",
                          }}
                          to={deliveryControlPanelLink}
                        >
                          Delivery Control Panel
                        </Link>
                      </button>
                    </li>
                  )}

                  {creator_id && (
                    <li>
                      <button type="button">
                        <span>
                          <img src="/img/addOrder.png" alt="dropdown" />
                        </span>
                        <Link
                          style={{ color: "inherit", textDecoration: "none" }}
                          to={groupOrderDashboardLink}
                        >
                          Corporate Order Dashboard
                        </Link>
                      </button>
                    </li>
                  )}
                  <li>
                    <button onClick={onLoad} type="button">
                      <span>
                        <img src="/img/dropdown2.svg" alt="dropdown" />
                      </span>
                      Log Out
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          ) : // ? <div className="welcome__back">
            //     <p>Welcome back</p>
            //     <div className="welcome__profile">
            //         {auth?.profile_image_url
            //             ? <div className="profile__image">
            //                 <img onClick={onClickProfile} src={
            //                     process.env.REACT_APP_API_URL + auth?.profile_image_url
            //                 } alt='profile'/>
            //             </div>
            //             : <div className="profile__image">
            //                 <span onClick={onClickProfile}>{auth?.first_name[0]?.toUpperCase() + auth?.last_name[0]?.toUpperCase()}</span>
            //             </div>
            //         }
            //         <div className="profile__info">
            //             <p>{auth?.first_name || 'User'}</p>
            //             <button onClick={onLoad} type='button'>Not You?</button>
            //         </div>
            //     </div>
            // </div>
            null}
        </div>
      </div>
    </header>
    </>
  );
};
export default Header;
